"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const useId_1 = require("../../utils/hooks/useId");
const Button_1 = require("../Button");
// styles
require("./input.scss");
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-input",
    size: "medium",
    type: "text",
    helpText: "",
    helpTextPosition: "up",
    showTogglePassword: false,
};
const Input = (_a) => {
    var { size, type, helpText, helpTextPosition, status, showTogglePassword, iconName, onIconClick, onInputLimitError, onClick, onChange, value, className, disabled, placeholder, maxLength, max, min, id, style, "data-testid": dataTestId } = _a, rest = __rest(_a, ["size", "type", "helpText", "helpTextPosition", "status", "showTogglePassword", "iconName", "onIconClick", "onInputLimitError", "onClick", "onChange", "value", "className", "disabled", "placeholder", "maxLength", "max", "min", "id", "style", "data-testid"]);
    const classList = (0, classnames_1.default)("tecma-input", {
        [`${size}`]: size,
        [`error-label-${helpTextPosition}`]: helpTextPosition,
        [`${status}`]: status,
        disabled,
    }, className);
    const inputId = (0, useId_1.useId)();
    const [inputType, setInputType] = (0, react_1.useState)(type);
    const togglePasswordIcon = inputType === "password" ? "view-off" : "view";
    const shouldShowTogglePassword = showTogglePassword && type === "password";
    const shouldShowIcon = shouldShowTogglePassword || iconName;
    const inputGroupClassList = (0, classnames_1.default)("input-group", {
        [`error-label-${helpTextPosition}`]: helpTextPosition,
        "with-icon": shouldShowIcon || type === "number",
    });
    const inputClassList = (0, classnames_1.default)({
        "without-placeholder": !placeholder,
        "is-active": value || value === 0,
    });
    const togglePassword = () => {
        return inputType === "password" ? setInputType("text") : setInputType("password");
    };
    const onButtonClick = (e) => {
        if (shouldShowTogglePassword) {
            return togglePassword(e);
        }
        if (onIconClick) {
            return onIconClick(e);
        }
        if (onClick) {
            return onClick(e);
        }
        return null;
    };
    const isNumberInRange = (number) => {
        let isValid = true;
        if (maxLength) {
            isValid = number.length <= maxLength;
        }
        if (min) {
            isValid = isValid && number >= min;
        }
        if (max) {
            isValid = isValid && number <= max;
        }
        return isValid;
    };
    const handleArrowStep = (newValue, e) => {
        if (max && newValue >= max) {
            e.target.value = max;
        }
        else if (min && newValue <= min) {
            e.target.value = min;
        }
        else {
            e.target.value = newValue;
        }
        onChange(e);
    };
    const handleChange = (e) => {
        const { value: inputValue } = Object.assign({}, e.target);
        /*
         * Here we must allow the onChange callback invocation even if the input is not in range
         * otherwise the user will not be able to write a value if the updated value is not correct
         * (with just one keystroke for example)
         */
        onChange(e);
        if (!isNumberInRange(inputValue) && onInputLimitError) {
            onInputLimitError(e);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classList, id: id, style: style, "data-testid": dataTestId }, { children: [helpText && (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "error-label" }, { children: helpText })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: inputGroupClassList }, { children: [(0, jsx_runtime_1.jsx)("input", Object.assign({ id: inputId, type: shouldShowTogglePassword ? inputType : type, className: inputClassList, disabled: disabled, onClick: onClick, value: value, maxLength: maxLength, onChange: handleChange, max: max, min: min }, rest)), (0, jsx_runtime_1.jsx)("label", Object.assign({ htmlFor: inputId }, { children: placeholder })), shouldShowIcon && ((0, jsx_runtime_1.jsx)(Button_1.Button, { className: "input-icon", onClick: onButtonClick, iconName: shouldShowTogglePassword ? togglePasswordIcon : iconName, transparent: true, disabled: disabled, size: size })), !shouldShowIcon && type === "number" && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "arrow-steps" }, { children: [(0, jsx_runtime_1.jsx)(Button_1.Button, { className: "input-icon arrow-button", transparent: true, iconName: "arrow-up", size: "extra-small", onClick: (e) => handleArrowStep(Number(value) + 1, e) }), (0, jsx_runtime_1.jsx)(Button_1.Button, { className: "input-icon arrow-button", transparent: true, iconName: "arrow-down", size: "extra-small", onClick: (e) => handleArrowStep(Number(value) - 1, e) })] })))] }))] })));
};
Input.defaultProps = defaultProps;
exports.default = react_1.default.memo(Input);
